// Dependencies
// -----------------------------------------------
import React from 'react';

// -----------------------------------------------
// COMPONENT->MAP-MARKER -------------------------
// -----------------------------------------------
export default class MapMarker extends React.Component {

  // Constructor
  // ---------------------------------------------
  constructor(props) {
    super(props);
  }

  // Render
  // ---------------------------------------------
  render() {
    return <div className="details-map-marker map-marker" />;
  }
}
